import React from "react";
import Logo from "../assets/icons/logo.svg";
import PrimaryBtn from "../components/partials/btn";
import Img from "../assets/images/image.png";
import { DetailType } from "../utils/types";
import Mail from "../assets/icons/mail.svg";
import Zap from "../assets/icons/zap.svg";
import Chart from "../assets/icons/bar-chart-2.svg";
import Half from "../assets/images/Mockup wrap.png";
import ArrowRight from "../assets/icons/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import Side1 from "../assets/images/side2.png";
import Side2 from "../assets/images/side3.png";
import Side3 from "../assets/images/side4.png";
import Side4 from "../assets/images/side5.png";
import Side5 from "../assets/images/side6.png";
import Side6 from "../assets/images/side7.png";
import Facebook from "../assets/icons/facebook.svg";
import Twitter from "../assets/icons/twitter.svg";
import Youtume from "../assets/icons/youtube.svg";
import Linkedln from "../assets/icons/linkedln.svg";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <DetailSection />
      <NewSection />
      <NewSection2 />
      {/* <TutorialSection /> */}
      <Footer />
    </div>
  );
};

const HeroSection = () => {
  const navigate = useNavigate();
  const downloadUserGuide = () => {
    const filePath = "/Data Syatems Maturity Assessment 3.pdf";
    const url = `${process.env.PUBLIC_URL}${filePath}`;
    const link = document.createElement("a");
    link.href = encodeURI(url);
    link.download = "ESAWAS-User-Guide.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <section className="lg:h-screen h-[60vh] relative w-full bg-[#000000CC]">
      <video
        className="absolute top-0 left-0 object-cover w-full h-full"
        autoPlay
        loop
        muted
      >
        <source src={require("../assets/images/herobg.mp4")} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute top-0 left-0 w-full h-full bg-black/70"></div>
      <div className="relative flex items-center justify-start h-full section-container">
        <img src={Logo} alt="" className="absolute top-6" />
        <div>
          <h1 className="lg:text-6xl text-4xl font-bold text-white lg:leading-[64px] tracking-[-2]">
            Data System <span className="text-primary">Maturity</span> <br />
            Assessment Tool
          </h1>
          <p className="max-w-3xl mt-6 text-base font-normal text-white lg:text-xl">
            Providing stakeholders with both quantifiable and qualitative
            results regarding the quality and effectiveness of data collection
            tools, data systems, and flows.
          </p>
          <div className="mt-8 flex items-center gap-4 lg:flex-row flex-col">
            <PrimaryBtn
              onClick={() => navigate("/login")}
              text="Access Dashboard"
            />
            <button
              className="text-white border rounded-lg px-8 py-2.5 text-base hover:bg-primary hover:text-white"
              onClick={downloadUserGuide}
            >
              Download User Guide
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const DetailSection = () => {
  const Arr: DetailType[] = [
    {
      icon: Mail,
      title: "Share team inboxes",
      desc: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.",
    },
    {
      icon: Zap,
      title: "Deliver instant answers",
      desc: "An all-in-one customer service platform that helps you balance everything your customers need to be happy.",
    },
    {
      icon: Chart,
      title: "Manage your team with reports",
      desc: "Measure what matters with Untitled's easy-to-use reports. You can filter, export, and drilldown on the data in a couple clicks.",
    },
  ];
  return (
    <section className="w-full py-20 bg-white">
      <div className="section-container">
        <p className="text-base font-semibold text-center text-primary">
          Easy Assessmment
        </p>
        <h3 className="mt-4 text-2xl font-semibold text-center lg:text-4xl text-sec">
          An all-in-one tool for your entire team
        </h3>
        <p className="mt-4 lg:text-b text-sm font-normal text-[#667085] max-w-4xl mx-auto text-center">
          Web-based platform for assessing water supply and sanitation data
          systems maturity at national and organisation level across the data
          value pipeline(from data collection, data ownership, data flow, data
          quality and data use) to support decisions in key sector areas of
          urban and rural WSS coverage, finance,regulation and utility
          operations.
        </p>
        <img src={Img} alt="" className="mx-auto mt-8" />
      </div>
      {/* <div className="bg-[#F9FAFB] py-16 mt-8 w-full">
        <div className="grid gap-5 section-container lg:grid-cols-3">
          {Arr?.map((it, i) => (
            <div key={i} className="w-full">
              <div
                style={{
                  border: "8px solid #F9F5FF",
                }}
                className="size-12 mx-auto bg-[#D7E2EC] rounded-full flex justify-center items-center"
              >
                <img src={it?.icon} alt="" className="" />
              </div>
              <h5 className="text-xl font-medium text-center text-sec">
                {it?.title}
              </h5>
              <p className="mt-1 text-base text-[#667085] text-center">
                {it?.desc}
              </p>
            </div>
          ))}
        </div>
      </div> */}
    </section>
  );
};

const NewSection = () => {
  return (
    <div>
      <section className="relative w-full py-8 lg:py-20">
        <img
          src={Side1}
          alt=""
          className="right-0 lg:top-56 lg:h-[500px] absolute hidden lg:block"
        />
        <div className="section-container">
          <h4 className="text-base font-semibold text-[#2070B8]">
            Achieve Desired Output
          </h4>
          <h1 className="mt-2 text-3xl leading-[44px] tracking-[-2%] font-semibold lg:mt-3 lg:text-4xl text-esblue">
            A seamless experience for organisations
          </h1>
          <small className="block mt-2 text-sm font-normal lg:mt-3 text-es-gray-100">
            Exploring our three level assessments.
          </small>
          <div className="py-8 lg:py-32">
            <div className="flex items-start gap-3 lg:gap-4">
              <div className="w-1 h-32 lg:h-52 bg-[#F2F4F7] flex-shrink-0 mt-2"></div>
              <div className="flex-1">
                <h4 className="text-lg font-medium lg:text-xl text-esblue">
                  Assessment Tool 1 - Ecosystem Level
                </h4>
                <p
                  style={{
                    lineHeight: "36px",
                  }}
                  className="mt-2 text-base font-normal tracking-wide lg:text-lg lg:max-w-xl text-es-gray-100 lg:leading-9"
                >
                  For countries to map the national enabling environment for WSS
                  data systems, involving a series of yes/no questions on
                  policies, processes, and initiatives at the national level and
                  mapping out responsibilities for collecting, monitoring and
                  using WSS KPIs
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative w-full py-8 overflow-visible lg:py-20">
        <img
          src={Side2}
          alt=""
          className="left-0 h-[500px] absolute hidden lg:block"
        />
        <div className="section-container">
          <div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-16">
            <div className="hidden w-1/2 lg:block"></div>
            <div className="w-full lg:w-1/2">
              <div className="py-8 lg:py-32">
                <div className="flex items-start gap-3 lg:gap-4">
                  <div className="w-1 h-32 lg:h-52 bg-[#F2F4F7] flex-shrink-0 mt-2"></div>
                  <div className="flex-1">
                    <h4 className="text-lg font-medium lg:text-xl text-esblue">
                      Assessment Tool 2 - Organisation Level
                    </h4>
                    <p
                      style={{
                        lineHeight: "36px",
                      }}
                      className="mt-2 text-base font-normal tracking-wide lg:text-lg lg:max-w-xl text-es-gray-100 lg:leading-9"
                    >
                      For organisations to assess both the national and internal
                      data systems enabling environment and map internal data
                      tools, systems and flows, evaluating their effectiveness
                      in practice.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative w-full py-8 lg:py-20">
        <img
          src={Side3}
          alt=""
          className="right-0 h-[500px] absolute hidden lg:block"
        />
        <div className="section-container">
          <div className="py-8 lg:py-32">
            <div className="flex items-start gap-3 lg:gap-4">
              <div className="w-1 h-32 lg:h-52 bg-[#F2F4F7] flex-shrink-0 mt-2"></div>
              <div className="flex-1">
                <h4 className="text-lg font-medium lg:text-xl text-esblue">
                  Assessment Tool 3 - Data Systems Map
                </h4>
                <p
                  style={{
                    lineHeight: "36px",
                  }}
                  className="mt-2 text-base font-normal tracking-wide lg:text-lg lg:max-w-xl text-es-gray-100 lg:leading-9"
                >
                  Map internal data systems by department assessing the
                  effectiveness of existing data collection tools and data
                  systems, integration and interlinkage of data systems in use
                  and how they inform core sector KPI
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
// const NewSection = () => {
//   return (
//     <div>
//       <section className="relative w-full py-20">
//         <img
//           src={Side1}
//           alt=""
//           className=" right-0 lg:top-56 lg:h-[500px] absolute hidden lg:block"
//         />
//         <div className="section-container">
//           <h4 className="text-2xl font-semibold text-[#2070B8]">
//             Achieve Desired Output
//           </h4>
//           <h1 className="mt-3 text-4xl font-semibold text-esblue">
//             A seamless experience for organisations
//           </h1>
//           <small className="mt-3 text-sm font-normal text-es-gray-100">
//             Exploring our three level assessments.
//           </small>
//           <div className="py-32">
//             <div className="flex items-center gap-4">
//               <div className="w-1 h-52 bg-[#F2F4F7]"></div>
//               <div className="">
//                 <h4 className="text-xl font-medium text-esblue">
//                   Assessment Tool 1 - Ecosystem Level
//                 </h4>
//                 <p
//                   style={{
//                     lineHeight: "36px",
//                     letterSpacing: "0%",
//                   }}
//                   className="max-w-xl mt-2 text-lg font-normal tracking-wide text-es-gray-100"
//                 >
//                   For countries to map the national enabling environment for WSS
//                   data systems, involving a series of yes/no questions on
//                   policies, processes, and initiatives at the national level and
//                   mapping out responsibilities for collecting, monitoring and
//                   using WSS KPIs
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="relative w-full py-20 overflow-visible">
//         <img
//           src={Side2}
//           alt=""
//           className="left-0 h-[500px] absolute hidden lg:block"
//         />
//         <div className="section-container">
//           <div className="flex flex-col items-start gap-16 lg:flex-row">
//             <div className="hidden w-1/2 lg:block"></div>
//             <div className="lg:w-1/2">
//               <div className="py-32">
//                 <div className="flex items-center gap-4">
//                   <div className="w-1 h-52 bg-[#F2F4F7]"></div>
//                   <div>
//                     <h4 className="text-xl font-medium text-esblue">
//                       Assessment Tool 2 - Organisation Level
//                     </h4>
//                     <p
//                       style={{
//                         lineHeight: "36px",
//                         letterSpacing: "0%",
//                       }}
//                       className="max-w-xl mt-2 text-lg font-normal tracking-wide text-es-gray-100"
//                     >
//                       For organisations to assess both the national and internal
//                       data systems enabling environment and map internal data
//                       tools, systems and flows, evaluating their effectiveness
//                       in practice.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="relative w-full py-20">
//         <img
//           src={Side3}
//           alt=""
//           className=" right-0 h-[500px] absolute hidden lg:block"
//         />
//         <div className="section-container">
//           <div className="py-32">
//             <div className="flex items-center gap-4">
//               <div className="w-1 h-52 bg-[#F2F4F7]"></div>
//               <div className="">
//                 <h4 className="text-xl font-medium text-esblue">
//                   Assessment Tool 3 - Data Systems Map
//                 </h4>
//                 <p
//                   style={{
//                     lineHeight: "36px",
//                     letterSpacing: "0%",
//                   }}
//                   className="max-w-xl mt-2 text-lg font-normal tracking-wide text-es-gray-100"
//                 >
//                   Map internal data systems by department assessing the
//                   effectiveness of existing data collection tools and data
//                   systems, integration and interlinkage of data systems in use
//                   and how they inform core sector KPI
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// const NewSection2 = () => {
//   return (
//     <div>
//       <section className="relative w-full py-20">
//         <img
//           src={Side4}
//           alt=""
//           className=" right-0 lg:top-56 lg:h-[500px] absolute hidden lg:block"
//         />
//         <div className="section-container">
//           <h4 className="text-2xl font-semibold text-[#2070B8]">
//             Achieve Desired Output
//           </h4>
//           <h1 className="mt-3 text-4xl font-semibold text-esblue">
//             Output Dasboards
//           </h1>
//           {/* <small className="mt-3 text-sm font-normal text-es-gray-100">
//             Exploring our three level assessments.
//           </small> */}
//           <div className="py-32">
//             <div className="flex items-center gap-4">
//               <div className="w-1 h-52 bg-[#F2F4F7]"></div>
//               <div className="">
//                 <h4 className="text-xl font-medium text-esblue">
//                   Output Dashboard Tool 1 - Ecosystem Level
//                 </h4>
//                 <p
//                   style={{
//                     lineHeight: "36px",
//                     letterSpacing: "0%",
//                   }}
//                   className="max-w-xl mt-2 text-lg font-normal tracking-wide text-es-gray-100"
//                 >
//                   Results of the enabling environment assessment at country
//                   level highlighting existing strengths and gaps to an effective
//                   enabling environment and providing granular insights on areas
//                   to address
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="relative w-full py-20 overflow-visible">
//         <img
//           src={Side5}
//           alt=""
//           className="left-0 h-[500px] absolute hidden lg:block"
//         />
//         <div className="section-container">
//           <div className="flex flex-col items-start gap-16 lg:flex-row">
//             <div className="hidden w-1/2 lg:block"></div>
//             <div className="lg:w-1/2">
//               <div className="py-32">
//                 <div className="flex items-center gap-4">
//                   <div className="w-1 h-52 bg-[#F2F4F7]"></div>
//                   <div>
//                     <h4 className="text-xl font-medium text-esblue">
//                       Output Dashboard Tool 2 - Organisation Levels
//                     </h4>
//                     <p
//                       style={{
//                         lineHeight: "36px",
//                         letterSpacing: "0%",
//                       }}
//                       className="max-w-xl mt-2 text-lg font-normal tracking-wide text-es-gray-100"
//                     >
//                       Results of the organisation level assessment demonstrating
//                       areas for interventions for good data practice and
//                       effective data flow, using a traffic light colour-coded
//                       visual map
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <section className="relative w-full py-20">
//         <img
//           src={Side6}
//           alt=""
//           className=" right-0 h-[500px] absolute hidden lg:block"
//         />
//         <div className="section-container">
//           <div className="py-32">
//             <div className="flex items-center gap-4">
//               <div className="w-1 h-52 bg-[#F2F4F7]"></div>
//               <div className="">
//                 <h4 className="text-xl font-medium text-esblue">
//                   Assessment Tool 3 - Data Systems Map
//                 </h4>
//                 <p
//                   style={{
//                     lineHeight: "36px",
//                     letterSpacing: "0%",
//                   }}
//                   className="max-w-xl mt-2 text-lg font-normal tracking-wide text-es-gray-100"
//                 >
//                   Data systems map as a diagrammatic overview showing the flow
//                   of data by department from the local level, linkages among
//                   systems and input to core sector KPIs. Provides insights on
//                   areas for strengthening to improve effectiveness of tools and
//                   systems
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

const NewSection2 = () => {
  return (
    <div>
      <div className="mt-16 section-container">
        <h4 className="text-base font-semibold text-[#2070B8]">
          Achieve Desired Output
        </h4>
        <h1 className="mt-2 text-2xl font-semibold lg:mt-3 lg:text-4xl text-esblue">
          Output Dashboards
        </h1>
      </div>
      <section className="relative w-full py-8 lg:py-20">
        <img
          src={Side4}
          alt=""
          className="left-0 lg:top-20 lg:h-[500px] absolute hidden lg:block"
        />
        <div className="section-container">
          <div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-16">
            <div className="hidden w-1/2 lg:block"></div>
            <div className="w-full lg:w-1/2">
              <div className="py-8 lg:py-32">
                <div className="flex items-center gap-3 lg:gap-4">
                  <div className="w-1 h-32 lg:h-52 bg-[#F2F4F7] flex-shrink-0 mt-2"></div>
                  <div className="flex-1">
                    <h4 className="text-lg font-medium lg:text-xl text-esblue">
                      Output Dashboard Tool 1 - Ecosystem Level
                    </h4>
                    <p
                      style={{
                        lineHeight: "36px",
                      }}
                      className="mt-2 text-base font-normal tracking-wide lg:text-lg lg:max-w-xl text-es-gray-100 lg:leading-9"
                    >
                      Results of the enabling environment assessment at country
                      level highlighting existing strengths and gaps to an
                      effective enabling environment and providing granular
                      insights on areas to address
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative w-full py-8 overflow-visible lg:py-20">
        <img
          src={Side5}
          alt=""
          className="right-0 h-[500px] absolute hidden lg:block"
        />
        <div className="section-container">
          <div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-16">
            {/* <div className="hidden w-1/2 lg:block"></div> */}
            <div className="w-full lg:w-1/2">
              <div className="py-8 lg:py-32">
                <div className="flex items-center gap-3 lg:gap-4">
                  <div className="w-1 h-32 lg:h-52 bg-[#F2F4F7] flex-shrink-0 mt-2"></div>
                  <div className="flex-1">
                    <h4 className="text-lg font-medium lg:text-xl text-esblue">
                      Output Dashboard Tool 2 - Organisation Levels
                    </h4>
                    <p
                      style={{
                        lineHeight: "36px",
                      }}
                      className="mt-2 text-base font-normal tracking-wide lg:text-lg lg:max-w-xl text-es-gray-100 lg:leading-9"
                    >
                      Results of the organisation level assessment demonstrating
                      areas for interventions for good data practice and
                      effective data flow, using a traffic light colour-coded
                      visual map
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative w-full py-8 lg:py-20">
        <img
          src={Side6}
          alt=""
          className="left-0 h-[500px] absolute hidden lg:block"
        />
        <div className="section-container">
          <div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-16">
            <div className="hidden w-1/2 lg:block"></div>
            <div className="w-full lg:w-1/2">
              <div className="py-8 lg:py-32">
                <div className="flex items-center gap-3 lg:gap-4">
                  <div className="w-1 h-32 lg:h-52 bg-[#F2F4F7] flex-shrink-0 mt-2"></div>
                  <div className="flex-1">
                    <h4 className="text-lg font-medium lg:text-xl text-esblue">
                      Assessment Tool 3 - Data Systems Map
                    </h4>
                    <p
                      style={{
                        lineHeight: "36px",
                      }}
                      className="mt-2 text-base font-normal tracking-wide lg:text-lg lg:max-w-xl text-es-gray-100 lg:leading-9"
                    >
                      Data systems map as a diagrammatic overview showing the
                      flow of data by department from the local level, linkages
                      among systems and input to core sector KPIs. Provides
                      insights on areas for strengthening to improve
                      effectiveness of tools and systems
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const TutorialSection = () => {
  const Arr = [
    {
      active: true,
      title: "Share team inboxes",
      desc: "Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop in the hiring process.",
    },
    {
      title: "Deliver instant follow-ups",
      desc: "An all-in-one hiring platform that helps you balance everything your candidates need to be happy and comfortable throughout the process.",
    },
    {
      title: "Manage your team with reports",
      desc: "Measure what matters with Untitled's easy-to-use reports. You can filter, export, and drilldown on the data in a couple clicks.",
    },
  ];
  return (
    <section className="relative w-full py-20 bg-white">
      <img
        src={Half}
        alt=""
        className="absolute right-0 hidden top-56 lg:block"
      />
      <div className="section-container">
        <p className="text-base font-semibold text-primary">
          Achieve Desired Output
        </p>
        <h3 className="mt-4 text-2xl font-semibold lg:text-4xl text-sec">
          A seamless experience for organisations
        </h3>
        <p className="mt-4 lg:text-xl text-base font-normal text-[#667085]">
          Treat candidates with a rich careers site and a wonderful application
          process.
        </p>
        <div className="max-w-xl mt-12">
          {Arr?.map((it, i) => (
            <div
              key={i}
              style={{
                borderLeft: `4px solid ${it?.active ? "#2070B8" : "#F2F4F7"}`,
              }}
              className="flex items-center h-40 pl-9"
            >
              <div>
                <h4 className="text-base font-medium lg:text-xl text-sec">
                  {it?.title}
                </h4>
                <p className="mt-2 text-base text-[#667085] font-normal">
                  {it?.desc}
                </p>
                <div className="flex items-center gap-4 mt-4 cursor-pointer">
                  <h6 className="text-sm font-medium lg:text-base text-primary">
                    Learn More
                  </h6>
                  <img src={ArrowRight} alt="" className="" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  // const links = ["terms", "privacy", "cookies"];
  const navigate = useNavigate();
  const iconLinks = [
    {
      icon: Twitter,
      url: "https://twitter.com/ESAWASreg",
      alt: "X (Twitter)",
    },
    {
      icon: Facebook,
      url: "https://web.facebook.com/ESAWASreg",
      alt: "Facebook",
    },
    {
      icon: Linkedln,
      url: "https://www.linkedin.com/company/esawas/",
      alt: "LinkedIn",
    },
    {
      icon: Youtume,
      url: "https://www.youtube.com/@ESAWASRegulators",
      alt: "YouTube",
    },
    {
      icon: Mail,
      url: "mailto:secretariat@esawas.org",
      alt: "Email",
    },
  ];
  const downloadUserGuide = () => {
    const filePath = "/Data Syatems Maturity Assessment 3.pdf";
    const url = `${process.env.PUBLIC_URL}${filePath}`;
    const link = document.createElement("a");
    link.href = encodeURI(url);
    link.download = "ESAWAS-User-Guide.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <section className="bg-[#1D2939]  pt-16 w-full">
      <div className="section-container border-b border-b-[#475467] pb-16 flex justify-center">
        <div>
          <h3 className="text-xl font-semibold text-center text-white lg:text-3xl">
            Let's get started on something great
          </h3>
          <p className="mt-4 text-base font-normal text-center text-[#EAECF0] lg:text-xl">
            Sign up to stay updated
          </p>
          <div className="flex items-center justify-center mt-8">
            <div className="relative w-96 h-11">
              <input
                style={{
                  border: "1px solid #D0D5DD",
                  boxShadow: "0px 1px 2px 0px #1018280D",
                }}
                type="text"
                placeholder="Enter Email Address"
                className="w-full h-full bg-white px-2 rounded-lg text-base font-normal text-[#07183A40]"
              />
              <button
                style={{
                  border: "1px solid #2070B8",
                  boxShadow: "0px 1px 2px 0px #1018280D",
                }}
                className="absolute right-2 h-9 px-6 text-sm font-medium text-white top-1 rounded-lg bg-[#2070B8]"
              >
                Subscribe
              </button>
            </div>
          </div>
          <div className="flex justify-center mt-5 gap-4">
            <button
              className="text-white border rounded-lg px-8 py-2.5 text-base hover:bg-primary hover:text-white"
              onClick={downloadUserGuide}
            >
              Download User Guide
            </button>
            <PrimaryBtn
              onClick={() => navigate("/login")}
              text="Access dashboard"
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between h-20 section-container">
        <h6 className="lg:text-base text-xs font-normal text-[#98A2B3]">
          © 2025 ESAWAS. All rights reserved.
        </h6>
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-4">
            {iconLinks.map(({ icon, url, alt }) => (
              <a href={url} target="_blank" rel="noopener noreferrer" key={alt}>
                <img src={icon} alt={alt} className="" />
              </a>
            ))}
          </div>
          {/* <div className="flex items-center gap-4">
            {links?.map((li) => (
              <p className="text-base font-normal text-[#98A2B3] capitalize">
                {li}
              </p>
            ))}
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Home;
